import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Gallery from '../entities/gallery'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import Category from '../entities/category'

interface GalleryState extends ListState<Gallery>{
    edit:Gallery,
    categories:Array<Category>,
    categ: any,
    galleryCategories:Array<Category>,
}
class GalleryMutations extends ListMutations<Gallery>{

}
class GalleryModule extends ListModule<GalleryState,any,Gallery>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Gallery>(),
        loading:false,
        edit:new Gallery(),
        categories: new Array<Category>(),
        categ:new Array<number>(),
        galleryCategories:new Array<Category>(),
    }
    actions={
        async getAll(context:ActionContext<GalleryState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Gallery/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gallery>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async update(context:ActionContext<GalleryState,any>,payload:any){
            await Ajax.put('/api/services/app/Gallery/Update',payload.data);
        },
        async delete(context:ActionContext<GalleryState,any>,payload:any){
            await Ajax.delete('/api/services/app/Gallery/Delete?Id='+payload.data.id);
        },
        async up(context:ActionContext<GalleryState,any>,payload:any){
            await Ajax.post('/api/services/app/Gallery/Up',payload.data);
        },
        async down(context:ActionContext<GalleryState,any>,payload:any){
            await Ajax.post('/api/services/app/Gallery/Down',payload.data);
        },
        async get(context:ActionContext<GalleryState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Gallery/Get?Id='+payload.data.Id);
            return reponse.data.result as Gallery;
        },
        async getAllCategories(context:ActionContext<GalleryState,any>){
            let reponse=await Ajax.get('/api/services/app/Category/GetAll');
            context.state.categories=reponse.data.result.items;
        }, 
        async getGalleryCategories(context:ActionContext<GalleryState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Gallery/GetGalleryCategories?Id='+payload.data.id);
            let array = []
            reponse.data.result.forEach(element => {
                array.push(element.simpleCategoryName);
            })
            context.state.edit.categories = array;
            //context.state.postCategories=reponse.data.result.items;
        }  
    };
    mutations={
        setCurrentPage(state:GalleryState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:GalleryState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:GalleryState,MediaItem:Gallery){
            state.edit=MediaItem;
        },
        setCategories(state:GalleryState,category:number[]){
            state.categ = category
        },
        setLoading(state:GalleryState,value:boolean){
            state.loading=value;
        },
    }
}
const gallerymodule=new GalleryModule();
export default gallerymodule;